export default function (props) {
    return <div className="validation-tool-tip">
        {props.children}
    </div>
}
